import { Image, Flex, Button } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import WithNavigationBarLayout from "src/components/WithNavigationBarLayout";
import { H2, BodyText } from "src/atoms/typography";
import getImageSrc from "src/utils/getImageSrc";
import { getAppValue } from "src/utils/environment";

export default function NoMonitoringsView({ onClose, openDescription }) {
  const { t } = useTranslation();
  const imageSource = getAppValue({
    barkio: "sad-dog.svg",
    bibino: "empty.svg"
  });
  return (
    <WithNavigationBarLayout
      navigationBarProps={{
        headingKey: "activityLog.heading",
        onClose
      }}
    >
      <Flex
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        width="320px"
        mx="auto"
        height="100%"
      >
        <Image src={getImageSrc(imageSource)} width="176px" />
        <H2 color="highEmphasis" textAlign="center" mt="24px">
          {t("activityLog.noMonitorings.heading")}
        </H2>
        <BodyText color="mediumEmphasis" textAlign="center" mt="8px">
          {t("activityLog.noMonitorings.text")}
        </BodyText>
        <Button
          variant="flatPrimary"
          onClick={openDescription}
          minWidth="196px"
          my="8px"
        >
          {t("buttons.howItWorks")}
        </Button>
      </Flex>
    </WithNavigationBarLayout>
  );
}
